/******************************************************************************************
 *	Manage Licensing Admins Controller
 ******************************************************************************************/
(function() {
  angular.module('rcControllers.manageLicensingAdmins', []).controller(
    'ManageLicensingAdminsController',
    /* @ngInject */
    function(
      $log,
      $scope,
      $state,
      $timeout,
      CurtainNotifications,
      LicensingAdmins,
      YesNoModal
    ) {
      $scope.admins = [];
      $scope.loadingAdmins = true;
      $scope.loadError = false;

      $scope.newAdminEmail = '';
      $scope.newAdminRole = 'LARO';
      $scope.roles = ['LARO', 'LARW'];
      $scope.submitting = false;
      $scope.submitAttempted = false;

      var refetchTimer = null;

      function loadAdmins() {
        $scope.loadingAdmins = true;
        $scope.loadError = false;

        LicensingAdmins.getAll()
          .then(function(admins) {
            $scope.admins = admins;
          })
          .catch(function(error) {
            $log.error('Failed to load licensing admins', error);
            $scope.loadError = true;
          })
          .finally(function() {
            $scope.loadingAdmins = false;
          });
      }

      loadAdmins();

      function showPendingBanner() {
        CurtainNotifications.show(
          CurtainNotifications.INFO_LONG,
          'manageLicensingAdmins.notifications.propagationDelay',
          null,
          65000
        );
      }

      function scheduleRefetch(admin) {
        if (refetchTimer) {
          $timeout.cancel(refetchTimer);
        }

        refetchTimer = $timeout(function() {
          refetchTimer = null;
          LicensingAdmins.getAll()
            .then(function(admins) {
              $scope.admins = admins;
              if (admin) {
                admin._pending = false;
              }
              CurtainNotifications.show(
                CurtainNotifications.SUCCESS,
                'manageLicensingAdmins.notifications.operationComplete'
              );
            })
            .catch(function(error) {
              $log.error('Background re-fetch of licensing admins failed', error);
              CurtainNotifications.show(
                CurtainNotifications.ERROR,
                'manageLicensingAdmins.notifications.refreshFailed'
              );
            });
        }, 60000);
      }

      $scope.addAdmin = function() {
        $scope.submitAttempted = true;

        if ($scope.addAdminForm.$invalid || $scope.submitting) {
          return;
        }

        $scope.submitting = true;
        showPendingBanner();

        var payload = {email: $scope.newAdminEmail, role: $scope.newAdminRole};

        LicensingAdmins.add(payload)
          .then(function() {
            var optimisticAdmin = {email: payload.email, role: payload.role, _pending: true};
            $scope.admins.push(optimisticAdmin);
            scheduleRefetch(optimisticAdmin);

            $scope.newAdminEmail = '';
            $scope.newAdminRole = 'LARO';
            $scope.submitAttempted = false;
          })
          .catch(function(error) {
            $log.error('Failed to add licensing admin', error);
            CurtainNotifications.show(CurtainNotifications.ERROR, 'generic.notifications.error');
          })
          .finally(function() {
            $scope.submitting = false;
          });
      };

      $scope.grantWriteAccess = function(admin) {
        YesNoModal.create({
          title: 'manageLicensingAdmins.confirmations.grantWriteAccess.title',
          message: 'manageLicensingAdmins.confirmations.grantWriteAccess.message',
          yesButtonLabel: 'manageLicensingAdmins.confirmations.grantWriteAccess.confirm',
          noButtonLabel: 'generic.buttons.cancel',
          type: 'notice',
        }).then(function(data) {
          if (!data || data.cancelled) {
            return;
          }

          admin._pending = true;
          showPendingBanner();

          LicensingAdmins.updateRole(admin.userId, {fromRole: 'LARO', toRole: 'LARW'})
            .then(function() {
              admin.role = 'LARW';
              scheduleRefetch(admin);
            })
            .catch(function(error) {
              $log.error('Failed to grant write access', error);
              CurtainNotifications.show(CurtainNotifications.ERROR, 'generic.notifications.error');
            });
        });
      };

      $scope.revokeWriteAccess = function(admin) {
        YesNoModal.create({
          title: 'manageLicensingAdmins.confirmations.revokeWriteAccess.title',
          message: 'manageLicensingAdmins.confirmations.revokeWriteAccess.message',
          yesButtonLabel: 'manageLicensingAdmins.confirmations.revokeWriteAccess.confirm',
          noButtonLabel: 'generic.buttons.cancel',
          type: 'notice',
        }).then(function(data) {
          if (!data || data.cancelled) {
            return;
          }

          admin._pending = true;
          showPendingBanner();

          LicensingAdmins.updateRole(admin.userId, {fromRole: 'LARW', toRole: 'LARO'})
            .then(function() {
              admin.role = 'LARO';
              scheduleRefetch(admin);
            })
            .catch(function(error) {
              $log.error('Failed to revoke write access', error);
              CurtainNotifications.show(CurtainNotifications.ERROR, 'generic.notifications.error');
            });
        });
      };

      $scope.removeAdmin = function(admin) {
        YesNoModal.create({
          title: 'manageLicensingAdmins.confirmations.remove.title',
          message: 'manageLicensingAdmins.confirmations.remove.message',
          yesButtonLabel: 'manageLicensingAdmins.confirmations.remove.confirm',
          noButtonLabel: 'generic.buttons.cancel',
          type: 'error',
        }).then(function(data) {
          if (!data || data.cancelled) {
            return;
          }

          admin._pending = true;
          showPendingBanner();

          LicensingAdmins.remove(admin.userId, admin.role)
            .then(function() {
              var idx = $scope.admins.indexOf(admin);
              if (idx !== -1) {
                $scope.admins.splice(idx, 1);
              }
              scheduleRefetch(null);
            })
            .catch(function(error) {
              $log.error('Failed to remove licensing admin', error);
              CurtainNotifications.show(CurtainNotifications.ERROR, 'generic.notifications.error');
            });
        });
      };

      $scope.goBack = function() {
        $state.go('licenseAdmin.search');
      };

      $scope.$on('$destroy', function() {
        if (refetchTimer) {
          $timeout.cancel(refetchTimer);
        }
      });
    }
  );
})();